import { getI18n } from 'react-i18next';

export const translateText = getI18n().t;
